module.exports = __webpack_public_path__ + "img/ballast-img-prod-584x584.50dc1db6.webp";